import { FilterItem } from "@/modules/common/filters";
import useOptionsQuery from "./useOptionsQuery";
import { ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS, AdminManagementCompaniesService } from "@/service/api/admin-management-companies";

interface UseManagementCompanyOwnersParams {
  currentValue?: FilterItem;
  enabled?: boolean;
}

const useManagementCompanyOwners = ({ currentValue, enabled }: UseManagementCompanyOwnersParams = {}) => {
  const result = useOptionsQuery(
    [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_OWNERS],
    () => AdminManagementCompaniesService.getOwners(),
    (page) => page.map((user) => ({ value: user.id, label: user.name })),
    () => undefined,
    "Erro ao carregar representantes.",
    currentValue,
    enabled,
  );

  const users = result.pages.flat();

  return { ...result, users };
};

export default useManagementCompanyOwners;
